module.exports = __webpack_public_path__ + "static/img/user-propile-level04.5241dec3.svg";